import store from '@store'

class ResourceService {
    multiFilterPost(filters) {
        store.commit('setExtraFilters', filters)
    }
}

export default new ResourceService()
